module.exports = __webpack_public_path__ + "img/i-mailbox-admin.ef51527a.svg";